/**
 * @generated SignedSource<<4aa744a2af11d27872ea4de5428bbf2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentPage_page$data = {
  readonly __typename: "ContentPage";
  readonly blocks: ReadonlyArray<{
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"AbstractBlock_contentBlock" | "AwardsListBlock_contentBlock" | "LocationBlock_contentBlock" | "LogoBlock_contentBlock" | "MarkdownBlock_contentBlock" | "PictureBlock_contentBlock" | "QuoteBlock_contentBlock" | "TextBlock_contentBlock">;
  }>;
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly siblingNavigation: {
    readonly " $fragmentSpreads": FragmentRefs<"SiblingNavigation_siblingNavigation">;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "ContentPage_page";
};
export type ContentPage_page$key = {
  readonly " $data"?: ContentPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentPage_page">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SiblingNavigation",
      "kind": "LinkedField",
      "name": "siblingNavigation",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SiblingNavigation_siblingNavigation"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "blocks",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AwardsListBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LocationBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AbstractBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LogoBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MarkdownBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PictureBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "QuoteBlock_contentBlock"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TextBlock_contentBlock"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPage",
  "abstractKey": null
};
})();

(node as any).hash = "674cb8d1567c1a8e469efed5c9121568";

export default node;
